import * as React from "react";
import { cn } from "../../lib/utils";
import { PROMO_BANNER_STYLES } from "./constants";
import type { PromoBannerProps } from "./types";

export const PromoBanner = React.forwardRef<HTMLElement, PromoBannerProps>(
  (
    {
      className,
      eyebrow,
      logoUrl = "/images/ticketon-travel-logo.svg",
      logoAlt = "Ticketon Travel",
      title,
      description,
      discountLabel,
      discountValue,
      discountSuffix,
      offerTitle,
      imageUrl,
      ctaLabel,
      ctaHref,
      onCtaClick,
      ...props
    },
    ref
  ) => {
    const discountNumberValue = discountValue.replace("%", "");
    const discountPercentSymbol = discountValue.includes("%") ? "%" : "";

    return (
      <section
        ref={ref}
        className={cn(PROMO_BANNER_STYLES.root, className)}
        {...props}
      >
        <div className={PROMO_BANNER_STYLES.card}>
          <div className={cn(PROMO_BANNER_STYLES.logoWrapper, "md:hidden")}>
            {logoUrl && (
              <img
                src={logoUrl}
                alt={logoAlt}
                className={PROMO_BANNER_STYLES.logo}
                loading="lazy"
                decoding="async"
              />
            )}
          </div>

          <div className={PROMO_BANNER_STYLES.imageWrapper}>
            <img
              src={imageUrl}
              alt={offerTitle}
              className={PROMO_BANNER_STYLES.image}
              loading="lazy"
              decoding="async"
            />
            <div className={PROMO_BANNER_STYLES.overlay}>
              <span className={PROMO_BANNER_STYLES.discountLabel}>
                {discountLabel}
              </span>
              <span className={PROMO_BANNER_STYLES.discountValue}>
                <span className={PROMO_BANNER_STYLES.discountNumber}>
                  {discountNumberValue}
                </span>
                <span className={PROMO_BANNER_STYLES.discountMeta}>
                  {discountPercentSymbol && (
                    <span className={PROMO_BANNER_STYLES.discountPercent}>
                      {discountPercentSymbol}
                    </span>
                  )}
                  <span className={PROMO_BANNER_STYLES.discountSuffix}>
                    {discountSuffix}
                  </span>
                </span>
              </span>
              <span className={PROMO_BANNER_STYLES.offerTitle}>{offerTitle}</span>
            </div>
          </div>

          <div className={PROMO_BANNER_STYLES.textSide}>
            <div className="hidden md:block">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={logoAlt}
                  className={PROMO_BANNER_STYLES.logo}
                  loading="lazy"
                  decoding="async"
                />
              ) : eyebrow && (
                <span className={PROMO_BANNER_STYLES.eyebrow}>{eyebrow}</span>
              )}
            </div>
            <h2 className={PROMO_BANNER_STYLES.title}>{title}</h2>
            <p className={PROMO_BANNER_STYLES.description}>{description}</p>
            <a href={ctaHref} className={PROMO_BANNER_STYLES.cta} onClick={onCtaClick}>
              {ctaLabel}
            </a>
          </div>
        </div>
      </section>
    );
  }
);

PromoBanner.displayName = "PromoBanner";
